<template>
  <mw-dialog size="large_large" :width="params.width ? params.width : ''" :height="params.height ? params.height : ''"   customClass="dialog__preView"  :footerButton="footerButton"  :closeOnClickModal="true"  :appendToBody="false" ref="dialog" :title="params.title || '选择'">
    <mw-view ref="view" :id="params.id"  :params="propParams" :tableParams="params.tableParams" :oneMenuShowTab="false"></mw-view>
  </mw-dialog>
</template>
<script>

  export default {
    props:{
      params:{
        type: Object
      }
    },
    data() {
      let formConfig=undefined;
      if(this.params && this.params.config){
        formConfig={
          getForm:this.params.config.getForm,
          config:this.params.config.getConfig(),
          way:'open'
        }
      }
      if(!this.params.multi){
        this.params.multiple = false;
      }
      let footerButton = [];
      let addClearBtn = true;
      var okBtnLabel = "确定";
      if(this.params){
        addClearBtn = !this.params.notShowClearBtn;
        okBtnLabel = this.params.okBtnLabel || "确定";
      }
      if(addClearBtn){
        footerButton.push({
          label: '清除',
          func: this.clearSure,
          type: 'default'
        })
      }
      footerButton.push({
          label: okBtnLabel,
          func: this.selectSure
      })
      footerButton.push({
        label: '取消',
        func: this.cancel,
        type: 'default'
      })
      return {
        propParams:formConfig!=undefined?formConfig:this.params,
        footerButton: footerButton
      }
    },

    mounted(){
      setTimeout(()=>{
        this.show();
      },200)
    },

    methods: {
      selectSure() {
        let me=this;
        let selected=me.mwRef('view').getCurrentSelection();
        if(!me.params.multi){
          if(selected.length>1){
            me.mwMsg('warning','最多选择一条记录！');
            return;
          }
        }
        if(this.params.func(selected,me)===false){
          return;
        }
        me.cancel();
      },
      clearSure(){
        let me=this;
        me.params.func();
        me.cancel();
      },
      cancel(){
        this.mwRef('dialog').hide();
      },
      show(){
        this.mwRef('dialog').show();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/view-select.vue